module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Beauty Insider Benefits',
        signIn: 'Sign in',
        signInSubText: 'to see your points and redeem rewards.',
        viewFeaturedOffers: 'View featured offers',
        promoLabel: 'Promo code',
        applyText: 'Apply',
        samplesText: 'Add up to 2 free samples',
        samplesSubText: '0 of 2 added for Get It Shipped',
        noBiPoints: 'You now have <b>0</b> Beauty Insider points.',
        biPoints: `You currently have <b>${vars[0]} points</b>`
    };

    return resources[label];
};
